import { useState } from "react";
import { ClipLoader } from "react-spinners";
import { Button, Modal } from "@components";
import { useWorkingSetActions } from "../hooks/useWorkingSetActions";

const RemoveWorkingSetDialog = ({ set, onClose, onRemoved }) => {
  const { remove } = useWorkingSetActions();
  const [removing, setRemoving] = useState(false);

  const confirm = async () => {
    setRemoving(true);
    const ok = await remove(set);
    setRemoving(false);
    if (ok) {
      onClose();
      onRemoved?.();
    }
  };

  return (
    <Modal isOpen={!!set} onClose={onClose} title={`Remove ${set?.name ?? ""}?`} size="sm">
      <div className="space-y-4 p-5">
        <p className="text-sm text-zinc-600">
          It comes off Today's tasks for everyone on your team. The accounts in it aren't touched.
        </p>
        <div className="flex gap-2">
          <Button type="button" className="shrink-0 rounded-lg" onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="button"
            color="danger"
            className="shrink-0 grow rounded-lg"
            disabled={removing}
            onClick={confirm}
          >
            {removing && <ClipLoader size={14} color="#fff" aria-hidden="true" className="mr-2" />}
            Remove working set
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveWorkingSetDialog;
